import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    questions: [],
    currentQuestion: undefined,
    previousQuestion: undefined,
    questionHistory: [],
};
export const questionsSlice = createSlice({
    name: 'questionReducer',
    initialState,
    reducers: {
        setActiveQuestionFromId: (state, action) => {
            state.currentQuestion = state.questions.find((question) => question.id === action.payload);
        },
        addQuestionToHistory: (state, action) => {
            state.questionHistory.push(action.payload);
        },
        removeLastQuestionFromHistory: (state) => {
            console.log('removeLastQuestionFromHistory');
            state.questionHistory.splice(-1, 1);
        },
        setActiveQuestion: (state, action) => {
            state.currentQuestion = action.payload;
        },
        updateQuestionList: (state, action) => {
            state.questions = action.payload;
            console.log('setting question to: ', action.payload[0]);
            state.currentQuestion = action.payload.length > 0 ? action.payload[0] : undefined;
        },
    },
});
export const { setActiveQuestionFromId, setActiveQuestion, updateQuestionList, addQuestionToHistory, removeLastQuestionFromHistory, } = questionsSlice.actions;
export const setCurrentQuestion = (value) => (dispatch) => Promise.resolve(dispatch(setActiveQuestion(value)));
export const setCurrentQuestionFromId = (value) => (dispatch) => Promise.resolve(dispatch(setActiveQuestionFromId(value)));
export const setQuestionList = (value) => (dispatch) => Promise.resolve(dispatch(updateQuestionList(value)));
export const getCurrentQuestion = (state) => state.questions.currentQuestion;
export const getQuestions = (state) => state.questions.questions;
export const addItemToHistory = (value) => (dispatch) => Promise.resolve(dispatch(addQuestionToHistory(value)));
export const removeLastItem = (dispatch) => Promise.resolve(dispatch(removeLastQuestionFromHistory));
export const getLastItemInHistory = (state) => state.questions.questionHistory.at(-1);
export default questionsSlice.reducer;
